import { LitElement, html, css } from 'lit';

export class CrusherTimeline extends LitElement {
  static styles = css`
    :host {
      display: block;
    }

    .timeline {
      background: var(--crusher-timeline-bg, var(--crusher-background-surface));
      -webkit-backdrop-filter: var(--crusher-timeline-backdrop, blur(var(--crusher-effect-blur-md)));
      backdrop-filter: var(--crusher-timeline-backdrop, blur(var(--crusher-effect-blur-md)));
      border: var(
        --crusher-timeline-border,
        var(--crusher-component-border-weight) solid var(--crusher-border-primary)
      );
      border-radius: var(--crusher-timeline-radius, var(--crusher-radius-lg));
      padding: var(--crusher-timeline-padding, var(--crusher-spacing-8));
      box-shadow: var(--crusher-timeline-shadow, none);
      position: relative;
    }

    :host([variant="plain"]) .timeline {
      --crusher-timeline-bg: transparent;
      --crusher-timeline-backdrop: none;
      --crusher-timeline-border: 0;
      --crusher-timeline-radius: 0;
      --crusher-timeline-padding: 0;
      --crusher-timeline-shadow: none;
    }

    :host([variant="split"]) .timeline {
      --crusher-timeline-bg: transparent;
      --crusher-timeline-backdrop: none;
      --crusher-timeline-border: 0;
      --crusher-timeline-radius: 0;
      --crusher-timeline-padding: 0;
      --crusher-timeline-shadow: none;
    }

    :host([variant="split"]) .timeline::before {
      content: "";
      position: absolute;
      width: var(--crusher-timeline-split-rail-width, var(--crusher-component-border-weight));
      height: 100%;
      left: var(--crusher-timeline-split-rail-left, 50%);
      top: 0;
      background: var(--crusher-timeline-split-rail-color, var(--crusher-border-primary));
    }

    @media (max-width: 767px) {
      :host([variant="split"]) .timeline::before {
        left: var(
          --crusher-timeline-split-mobile-rail-left,
          calc(var(--crusher-spacing-8) + var(--crusher-spacing-1) - var(--crusher-component-border-weight))
        );
      }
    }

    ::slotted(crusher-timeline-item:last-of-type) {
      padding-bottom: 0;
    }
  `;

  render() {
    return html`
      <div class="timeline">
        <slot></slot>
      </div>
    `;
  }
}

customElements.define('crusher-timeline', CrusherTimeline);
